class CalculationContainer {

    protected defaultCalculation: string = "monthly";
    protected calculations: Array<{ value: string, translationKey: string }> = [
        {
            value: 'monthly',
            translationKey: "calculation-month"
        },
        {
            value: 'yearly',
            translationKey: "calculation-year"
        }
    ];

    public all(): Array<{ value: string, translationKey: string }> {
        return this.calculations;
    }
}

export default new CalculationContainer();
